import styles from './products-shipping-section.module.scss'
import cl from 'classnames'
import { observer } from 'mobx-react-lite'
import { SectionContainer, H2, TableContainer, TableHeader, Text1, TableBodyContainer,
    TableBodyLine, formatPrice, } from '@touche-lts/panel-ui/dist'
import { useRootStore } from 'mobx-stores/store-provider'
import { SwitchButton } from 'components/shared/switch-button/switch-button'
    

const shippingsTableWidths = {
    name: 17,
    deliveryTime: 12,
    price: 20,
    countries: 45,
    enable: 6
}

const ProductsShippingSectionComponent = (props) => { // TODO-A To put a model here
    const {
        className,
        style,
        editMode,
        productId
    } = props

    const {
        productsShippingsStore: {
            productBrandShippingsStore,
            setActiveStoreProp
        }
    } = useRootStore();

  return (
    <SectionContainer 
        className={cl(className)}
        style={style}
        colorPreset='dark' 
        extraPaddingBottom
    >
        <H2 className={styles.sectionHeadingWithButton} colorPreset='dark'>
            Shipping options
        </H2>
        <TableContainer colorPreset='dark' noBoxShadow style={{ marginTop: 15 }}>
            <TableHeader
                noFilters
                colorPreset='dark'
                tableColumns={[
                {
                    label: 'name',
                    widthPercentage: shippingsTableWidths.name
                },
                {
                    label: 'delivery time',
                    widthPercentage: shippingsTableWidths.deliveryTime
                },
                {
                    label: 'price',
                    widthPercentage: shippingsTableWidths.price
                },
                {
                    label: 'countries',
                    widthPercentage: shippingsTableWidths.countries
                },
                {
                    label: 'enable',
                    widthPercentage: shippingsTableWidths.enable
                }
                ]}
            />
            <TableBodyContainer>
                {productBrandShippingsStore.map((shipping, key) => {
                return (
                    <TableBodyLine
                    key={shipping.id}
                    colorPreset='dark'
                    cells={[
                        {
                        widthPercentage: shippingsTableWidths.name,
                        children: <Text1 colorPreset='dark' bold overflowEllipsis>{shipping.name}</Text1>
                        },
                        {
                        widthPercentage: shippingsTableWidths.deliveryTime
                        },
                        {
                        widthPercentage: shippingsTableWidths.price,
                        children: (
                            <div>
                            <Text1 colorPreset='dark' overflowEllipsis>{formatPrice(shipping.price)}</Text1>
                            {shipping.freeAmount && (
                                <Text1 colorPreset='dark' overflowEllipsis>
                                Free shipping above: {formatPrice(shipping.freeAmount)}
                                </Text1>
                            )}
                            </div>
                        )
                        },
                        {
                        widthPercentage: shippingsTableWidths.countries,
                        className: cl(styles.countryTags, styles.scrollable),
                        children: (shipping.countries || []).map(country => (
                            <span key={country} className={cl(styles.lightTag)}>
                                {country}
                            </span>
                        ))
                        },
                        {
                        widthPercentage: shippingsTableWidths.enable,
                        children: (
                            <SwitchButton
                            isOn={shipping.active}
                            onChange={() => setActiveStoreProp(!shipping.active, key, editMode, productId)}
                            />
                        )
                        }
                    ]}
                    />
                )
                })}
            </TableBodyContainer>
        </TableContainer>
    </SectionContainer>
  )
}

const ProductsShippingSectionProduct = observer(ProductsShippingSectionComponent)
export { ProductsShippingSectionProduct }
